import isString from 'lodash/isString'
import isNil from 'lodash/isNil'
import toString from 'lodash/toString'
import { cn } from '@klear/ui/lib/utils'
import type { ExtractionField } from '@/app/document-review/approval-items'

const CONFIDENCE_DOTS: Record<string, string> = {
  medium: 'bg-amber-500',
  low: 'bg-red-500'
}

export function extractionValueText(value: unknown): string {
  if (isNil(value)) return 'Left empty'
  if (isString(value)) return value === '' ? 'Left empty' : value
  return toString(value)
}

export function ExtractionReceipt({ extraction, className }: { extraction: ExtractionField; className?: string }) {
  const dot = CONFIDENCE_DOTS[extraction.confidence]

  if (extraction.sources.length === 0) {
    return (
      <div className={cn('flex items-start gap-1.5 text-xs', className)}>
        <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-amber-500" aria-hidden />
        <span className="text-amber-600 dark:text-amber-500">Inferred — no quote on the page</span>
      </div>
    )
  }

  return (
    <div className={cn('flex flex-col gap-0.5 text-xs', className)}>
      {extraction.sources.map((source, index) => (
        <div key={`${source.page}-${index}`} className="flex items-start gap-1.5">
          {dot !== undefined && <span className={cn('mt-1 h-2 w-2 shrink-0 rounded-full', dot)} aria-hidden />}
          <span className="text-muted-foreground shrink-0 font-mono">p.{source.page}</span>
          <span className="text-muted-foreground italic">&ldquo;{source.quote}&rdquo;</span>
        </div>
      ))}
    </div>
  )
}
